import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PagesComponent } from './pages/pages.component';
import { MenuComponent } from './shared/menu/menu.component';
import { AppSettings } from './app.settings';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AlertsModule, AlertsService } from '@clavisco/alerts';
import { Miscellaneous } from '@clavisco/core';
import { LinkerModule, LinkerService } from '@clavisco/linker';
import { OverlayModule, OverlayService } from '@clavisco/overlay';
import { environment } from 'src/environments/environment';
import { AuthenticationInterceptor } from './interceptors/authentication.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { UrlInterceptor } from './interceptors/url.interceptor';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { LoginModule } from '@clavisco/login';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MenuModule } from "@clavisco/menu";
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CurrencyPipe } from '@angular/common';
import { DatePipe } from '@angular/common';
import { ViewerComponent } from './pages/logs/viewer/viewer.component';
import { LogsViewerModule } from '@clavisco/logs-viewer';

@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    MenuComponent,
    ViewerComponent
  ],
  imports: [
    BrowserModule,
    MatTooltipModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    LinkerModule,
    AlertsModule,
    OverlayModule,
    LoginModule,
    MatSidenavModule,
    MenuModule,
    MatIconModule,
    MatToolbarModule,
    MatDialogModule,
    MatSelectModule,
    MatButtonModule,
    LogsViewerModule
  ],
  providers: [
    AppSettings,
    CurrencyPipe,
    DatePipe,
    {
      provide: 'LinkerService',
      useClass: LinkerService
    },
    {
      provide: 'OverlayService',
      useClass: OverlayService
    },
    {
      provide: 'AlertsService',
      useClass: AlertsService
    },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recatchaSiteKey
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Miscellaneous.Interceptors.HttpAlertInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Miscellaneous.Interceptors.PagedRequestInterceptor,
      multi: true
    },
    {
      useClass: UrlInterceptor,
      provide: HTTP_INTERCEPTORS,
      multi: true
    },
    {
      useClass: AuthenticationInterceptor,
      provide: HTTP_INTERCEPTORS,
      multi: true
    },
    {
      useClass: ErrorInterceptor,
      provide: HTTP_INTERCEPTORS,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
